export const anotherCity = {
  id: 29751,
  name_full_name_ua: 'Інші населені пункти України',
  zone: 5,
};
